<script setup>
import {reactive, onMounted, computed} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextIdA: String
});

const data = reactive({
  checks: 0,
  totalPayments: 0,
  sumPayments: 0,
  date: '',
  noIdMatch: false,
});


onMounted(()=>{

  ApiWrapper.post('payments', 'batch-stats', {
    batchId: props.contextIdA
  })
  .then((response) => {
    if(response.checks){
      data.checks = response.checks;
    }
    if(response.totalPayments){
      data.totalPayments = response.totalPayments;
    }
    if(response.sumPayments){
      data.sumPayments = response.sumPayments;
    }
    if(response.date){
      data.date = response.date;
    }
  })
  .catch((e)=>{
    ToastUtil.error(e);
  })
  .finally(()=>{
    data.loading = false
  })
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto" v-if="!data.noIdMatch">
      <v-toolbar flat color="white">
        <v-toolbar-title>Batch Stats</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-card-subtitle>Batch {{props.contextIdA}}</v-card-subtitle>
      <v-row density="compact" justify="space-between">
        <v-col cols="12" sm="3">
          <h1 style="text-align: center">{{data.date}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Batch Creation Date
          </p>
        </v-col>

        <v-col cols="12" sm="3">
          <h1 style="text-align: center">{{data.sumPayments}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Sum Of Payments
          </p>
        </v-col>

        <v-col cols="12" sm="3">
          <h1 style="text-align: center">{{data.totalPayments}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Count Of Payments
          </p>
        </v-col>

        <v-col cols="12" sm="3">
          <h1 style="text-align: center">{{data.checks}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Unique Checks
          </p>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="elevation-2" height="auto" width="auto"  v-else>
      <v-toolbar flat color="yellow">
        <v-toolbar-title>No Batches match this ID</v-toolbar-title>
      </v-toolbar>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>